import React, {Component} from 'react';
import './FancyRadiobox.css';

class FancyRadiobox extends Component {
	constructor() {
		super();

		this.onCheck = () => !this.props.checked && this.props.onCheck();
	}

	render() {
		const {checked, title} = this.props;

		return (
			<div
				className={`FancyRadiobox ${checked ? 'checked' : ''}`}
				onClick={this.onCheck}
				title={title}>
				<span className="icon icon-check" />
			</div>
		);
	}
}

export default FancyRadiobox;



// WEBPACK FOOTER //
// ./src/widgets/FancyRadiobox.js